<template>
	<div class="details">
		<div class="container">
			<div class="row">
				<div class="col-md-9 mx-auto">
					<div class="form-box review-box completed-form-box">
						<img src="../assets/icons/check.png" alt="Check" class="envelope-icon">
						<h1>Welcome <strong>{{ firstName }}</strong>, you're now an investor!</h1>
						<p>Your order was placed and will likely settle within 7 days. Once complete, your money will be instantly invested in dozens of projects across the country.</p>
						<a :href="investmentPortalEndPoint" class="btn btn-light mt-5">Continue to Investment Portal</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {PORTAL_URL} from "@/main";

export default {
    name: "CompletedForm",
    beforeMount() {
        // Verify the previous step is completed
        if(!this.$store.getters.review.finished) {
            this.$router.replace("/review");
        }
    },
    data() {
        return {
            firstName: this.$store.getters.auth.firstName,
		}
	},
	computed: {
        token() {
            return this.$store.getters.token;
		},
        investmentPortalEndPoint() {
            return PORTAL_URL + "/auth?t=" + this.token;
		},
	},
}
</script>